<template>
    <div class="animated fadeIn">
        <div>
            <b-card>
                <div slot="header">
                    <strong style="margin-left: 5px">Create a Codelab for project "{{ activeProject.name }}"</strong>
                </div>

                <div role="tablist" class="tabbed-form">
                    <b-card no-body class="mb-1">
                        <b-card-header @click="toggleStep(0)" header-tag="header" class="p-1 form-step-name" role="tab">
                            <img src="../../assets/gcp-icons/step1.png" />
                            {{ tabs[0] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[0]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group label="Name" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.codelabData.name.$model"
                                                    type="text"
                                                    ref="category-name"
                                                    placeholder="Enter the category name"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('codelabData.name', 0)"
                                                    invalid="This field is required"
                                                    valid="Name is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group label="Category" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8">
                                                <v-select
                                                    class="text-nowrap"
                                                    v-model="category"
                                                    label="name"
                                                    placeholder="Select Category"
                                                    :options="categories"
                                                    id="category-multiselect"
                                                ></v-select>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        label="Password-protection"
                                        label-for="password-protection"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-form-checkbox-group id="password-protection" class="pill-pushdown">
                                            <label
                                                class="switch switch-label switch-pill switch-primary"
                                                data-children-count="1"
                                            >
                                                <input
                                                    class="switch-input"
                                                    type="checkbox"
                                                    v-model="passwordProtection"
                                                />
                                                <span
                                                    class="switch-slider"
                                                    data-checked="On"
                                                    data-unchecked="Off"
                                                ></span>
                                            </label>
                                        </b-form-checkbox-group>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="passwordProtection"
                                        label="Password"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-row>
                                            <b-col md="8">
                                                <b-form-input
                                                    v-if="showPassword"
                                                    v-model="$v.codelabData.password.$model"
                                                    type="text"
                                                    ref="codelab-password"
                                                    placeholder="Enter the password"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-else
                                                    v-model="$v.codelabData.password.$model"
                                                    type="password"
                                                    ref="codelab-password"
                                                    placeholder="Enter the password"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('codelabData.password', 0)"
                                                    invalid="This field is required"
                                                    valid="Password is valid"
                                                ></Feedback>
                                            </b-col>
                                            <b-col>
                                                <b-form-checkbox-group id="password-show">
                                                    <label
                                                        class="switch switch-label switch-pill switch-primary switch-show-password"
                                                        data-children-count="1"
                                                    >
                                                        <input
                                                            class="switch-input"
                                                            type="checkbox"
                                                            v-model="showPassword"
                                                        />
                                                        <span
                                                            class="switch-slider"
                                                            data-checked="Show"
                                                            data-unchecked="Hide"
                                                        ></span>
                                                    </label> </b-form-checkbox-group
                                            ></b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        label="Warsaw Analytics Members only"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-form-checkbox-group class="pill-pushdown">
                                            <label
                                                class="switch switch-label switch-pill switch-primary"
                                                data-children-count="1"
                                            >
                                                <input
                                                    class="switch-input"
                                                    type="checkbox"
                                                    v-model="$v.codelabData.warsawAnalyticsOnly.$model"
                                                />
                                                <span
                                                    class="switch-slider"
                                                    data-checked="On"
                                                    data-unchecked="Off"
                                                ></span>
                                            </label>
                                        </b-form-checkbox-group>
                                    </b-form-group>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('codelabData', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="toggleStep(1)"
                                                :disabled="checkPage[0] && $v.codelabData.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Next
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header
                            @click="toggleStep(1)"
                            :disabled="$v.codelabData.$invalid"
                            header-tag="header"
                            class="p-1 form-step-name"
                            role="tab"
                        >
                            <img src="../../assets/gcp-icons/step2.png" />
                            {{ tabs[1] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[1]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group
                                        v-if="tokens.length < 1"
                                        label="Authorize with Google Docs"
                                        :horizontal="true"
                                        :label-cols="2"
                                    >
                                        <b-row>
                                            <b-col md="8">
                                                <img
                                                    @click="retrieveGoogleToken"
                                                    src="../../assets/gcp-icons/AuthorizeButton.png"
                                                />
                                                <Feedback
                                                    :state="authNotClicked ? null : authorized"
                                                    invalid="This field is required"
                                                    valid="Project is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        v-else
                                        label="Choose Google Docs Account"
                                        :horizontal="true"
                                        :label-cols="2"
                                    >
                                        <b-row>
                                            <b-col md="8">
                                                <v-select
                                                    class="text-nowrap"
                                                    v-model="$v.docsData.token.$model"
                                                    label="email"
                                                    placeholder="Select Token"
                                                    :options="tokens"
                                                    id="token-multiselect"
                                                ></v-select>
                                                <Feedback
                                                    :state="validateRef('docsData.token')"
                                                    invalid="This field is required"
                                                    valid="Account is valid"
                                                ></Feedback>
                                            </b-col>
                                            <b-col md="8">
                                                <span id="reauthorize-google">
                                                    or
                                                    <img
                                                        @click="retrieveGoogleToken"
                                                        src="../../assets/gcp-icons/AuthorizeButton.png"
                                                    />
                                                    to use a different Account
                                                </span>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="authorized || tokens.length > 0"
                                        label="Doc URL"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.docsData.url.$model"
                                                    type="text"
                                                    ref="google-docs-url"
                                                    placeholder="Enter the Google Docs URL"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('docsData.url', 0)"
                                                    invalid="This field is required"
                                                    valid="URL is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <Feedback :state="codelabError.state" :invalid="codelabError.message"></Feedback>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('codelabData', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="createCodelab"
                                                :disabled="checkPage[0] && $v.codelabData.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Create
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-card>
        </div>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'

import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'

import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            tabs: ['Codelab settings', 'Google Docs Settings'],
            tabIndex: 0,
            codelabData: {
                name: '',
                password: '',
                warsawAnalyticsOnly: false,
            },
            docsData: {
                url: '',
                token: null,
            },
            passwordProtection: false,
            showPassword: false,
            codelabError: {
                state: true,
                message: '',
            },
            authNotClicked: true,
            authorized: false,
        }
    },
    mixins: [validationMixin],
    validations: {
        codelabData: {
            name: {required},
            password: {
                required: requiredIf(function() {
                    return this.passwordProtection
                }),
            },
            warsawAnalyticsOnly: {},
        },
        docsData: {
            url: {
                required,
                docsUrl: string => {
                    const reg = /^https:\/\/docs.google.com\/document\/d\//
                    return reg.test(string)
                },
            },
            token: {required},
        },
    },
    components: {
        Feedback,
        Loading,
    },
    computed: {
        ...mapGetters({
            activeProject: 'project/active',
            categories: 'category/categories',
            tokens: 'google/tokens',
        }),
        tabOpen() {
            return this.tabs.map((tab, index) => (index === this.tabIndex ? true : false))
        },
        category: {
            get() {
                return this.$store.state.category.active
            },

            set(value) {
                this.$store.commit('category/SET_CATEGORY', value)
            },
        },
    },
    async created() {
        this.checkPage = this.tabs.map(el => false)
        this.$store.dispatch('google/init')
        this.fetchCategories()
    },
    methods: {
        createCodelab() {
            this.checkPage[1] = true
            this.$forceUpdate()
            if (!this.$v.$invalid) {
                this.$v.$reset()

                const data = {
                    codelabData: {
                        name: this.codelabData.name,
                        projectId: this.activeProject.id,
                        docUrl: this.docsData.url,
                        password: this.passwordProtection ? this.codelabData.password : undefined,
                        warsawAnalyticsOnly: this.codelabData.warsawAnalyticsOnly
                            ? this.codelabData.warsawAnalyticsOnly
                            : undefined,
                        categoryId: this.category.id,
                        tokenId: this.docsData.token.id,
                    },
                }

                this.$store.commit('loading/PROCESSING', `Creating the Codelab...`)
                this.$store
                    .dispatch('codelab/createCodelab', data)
                    .then(category => {
                        this.$store.commit('loading/PROCESSED')
                        this.$router.push({
                            path: '/codelabs',
                        })
                    })
                    .catch(exception => {
                        this.codelabError.state = false
                        this.codelabError.message = exception.response.data
                        this.$store.commit('loading/PROCESSED')
                    })
            }
        },

        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },

        toggleStep(step) {
            this.tabIndex = step
            this.$forceUpdate()
        },

        async fetchCategories() {
            const categories = await this.$store.dispatch('category/getCategories', this.activeProject.id)
            if (localStorage.activeCategoryId) {
                const activeCategory = categories.find(el => el.id === localStorage.activeCategoryId)
                if (activeCategory) {
                    this.$store.commit('category/SET_CATEGORY', activeCategory)
                }
            }
        },

        retrieveGoogleToken() {
            const options = {
                scopes: 'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/userinfo.email',
            }
            this.authNotClicked = false

            this.$store.commit('loading/PROCESSING', `Authorizing with Google Docs...`)
            this.$store
                .dispatch('google/authorizeGoogleApi', options)
                .then(token => {
                    this.$store.commit('loading/PROCESSED')
                    this.authorized = true
                    this.docsData.token = token
                    this.codelabError = {}
                })
                .catch(exception => {
                    console.error(exception)
                    this.$store.commit('loading/PROCESSED')
                    this.codelabError.state = false
                    this.codelabError.message = exception.response.data.additionalInfo
                })
        },
    },
}
</script>

<style lang="scss">
.switch-show-password {
    width: 70px;
    padding-top: 5px;
    .switch-input:checked ~ .switch-slider::before {
        transform: translateX(42px);
    }
}

.pill-pushdown {
    padding-top: 5px;
}

#reauthorize-google {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.7rem;
    opacity: 0.8;
    img {
        width: 150px;
    }
}
</style>
